import { render } from "./ChronicleDetailView.vue?vue&type=template&id=f8025c84&scoped=true"
import script from "./ChronicleDetailView.vue?vue&type=script&lang=js"
export * from "./ChronicleDetailView.vue?vue&type=script&lang=js"

import "./ChronicleDetailView.vue?vue&type=style&index=0&id=f8025c84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8025c84"]])

export default __exports__